import React from 'react';

import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';

function BooleanCheckbox({ value, onChange }) {
  const { t } = useTranslation();
  const checked = value === true || value === 'true' || value === '1';

  const handleChange = (newValue) => {
    // Pass the boolean value to Form.Item
    if (onChange) {
      onChange(newValue ? true : undefined);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Switch
        checked={checked}
        onChange={handleChange}
        size="small"
      />
      <span style={{ fontSize: '14px', color: '#666' }}>
        {checked ? t('common.yes', { defaultValue: '是' }) : t('common.no', { defaultValue: '否' })}
      </span>
    </div>
  );
}

export default BooleanCheckbox;
